import { render, staticRenderFns } from "./CasesUpdated.vue?vue&type=template&id=253a95f7&scoped=true&"
import script from "./CasesUpdated.vue?vue&type=script&lang=js&"
export * from "./CasesUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253a95f7",
  null
  
)

export default component.exports